import { XCircleIcon, X } from "lucide-react";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

const ExportModel = ({
  isOpen,
  onClose,
  exportData,
  exportAllcorporateData,
  exportAllData,
  type
}) => {
 


  const token=localStorage.getItem("Admin");
  const userData = JSON.parse(token);
  const userEmail = userData?.data?.email;


    const [email, setEmail] = useState(userEmail);

    const handelExportApply=()=>{
        if(email){
            if(type === "all"){
                exportAllData(null,email);
            }else if(type === "corporate"){
                exportAllcorporateData(null,email);
            }else if(type === "individual"){
                exportData(email);
            }else{
              exportData(email);
            }
            onClose();
        }
    }


  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-40 transition-opacity duration-300 bg-black bg-opacity-25"
          onClick={() => onClose(false)}
        />
      )}
      <div
        className={`fixed right-0 top-0 h-full w-[500px] bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        } flex flex-col`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-2 border-b border-gray-200 bg-[#FCDD00]">
          <div className="flex items-center">
            <h2 className="my-[7px] text-xl font-semibold text-gray-900">
              Export
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 transition-colors duration-200 rounded-full hover:bg-white hover:bg-opacity-50"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        {/* Filter Content */}
        <div className="flex-1 p-6 space-y-6 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400">
          <span className="font-Poppins block text-[15px] xl:text-base">
          Please enter the email address where you would like to receive the exported data.
          </span>
          <form onSubmit={handelExportApply} id="exportForm">

          <div className="col-span-12 md:col-span-4">
            <span className="font-Poppins block text-[15px] xl:text-base">
              Email Id<span className="text-[#fc0000]">*</span> :
            </span>
            <input
              className="py-[10px] xl:py-3 px-4 w-full rounded-lg bg-[#FFFCE1] text-sm outline-[#FCDD00]"
              type="email"
              placeholder="Enter Email Id"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="off"
            />
          </div>
          </form>
        </div>

        {/* Footer Actions */}
        <div className="flex flex-row gap-3 p-6 border-t border-gray-200 bg-gray-50">
          <button
        form="exportForm"
            className="w-full bg-[#FCDD00] text-black py-3 px-4 rounded-lg hover:bg-[#FCDD00] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200 font-medium"
          >
            Export
          </button>

          <button
            onClick={onClose}
            className="flex items-center justify-center w-full px-4 py-3 font-medium text-gray-700 transition-colors duration-200 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
          >
            Close
          </button>
        </div>
      </div>
    </>
  );
};

export default ExportModel;